import { createContext, useContext } from "react";

export const LanguageContext = createContext(null);

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);

    if (!ctx) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }

    return ctx;
};
